import { FC, useContext, useEffect } from 'react';
import UnverifiedStaffAccountContext, {
    UnverifiedStaffAccountProvider,
    EUnverifiedStaffAccountUiState,
} from '../../contexts/UnverifiedStaffAccountContext';
import PageLayout from '../../layout/PageLayout/PageLayout';
import Card from '../../components/Card/Card';
import styles from './UnverifiedStaffAccountScreen.module.scss';
import common from '../../util/scss/common.module.scss';
import { Redirect } from 'react-router';
import { ERoutes } from '../../util/constants';
import { IconEnvelope } from '../../icons/Icons';
import API from '../../api/api';
import GlobalContext from '../../contexts/GlobalContext';
import { Alert, Link, Snackbar } from '@mui/material';

const Unverified: FC = () => {
    const { language, fullLoginLink } = useContext(GlobalContext);
    const { email, requestVerificationEmail, showToaster } = useContext(UnverifiedStaffAccountContext);

    const handleContinueToLoginClick = () => {
        API.post.trackEvent({
            event: 'Sign In || Staff Sign in | Verification | Verification hard stop | Button - Continue to sign in',
        });
    };

    const handleResendEmailClick = () => {
        API.post.trackEvent({
            event: 'Sign In || Staff Sign in | Verification | Verification hard stop | Button - Resend verification email',
        });
        requestVerificationEmail();
    };

    useEffect(() => {
        API.post.trackEvent({ event: 'Sign In || Staff Sign in | Verification | Verification hard stop' });
    }, []);

    return (
        <>
            <Card>
                <section className={common.icon}>
                    <IconEnvelope />
                </section>
                <header>
                    <h1 className={common.pageHeader}>{language.unverified.header}</h1>
                </header>
                <main>
                    <p className={styles.email}>{email}</p>
                </main>
                <footer className={styles.footer}>
                    <p>
                        {`${language.unverified.descStaff}`}{' '}
                        <Link href={fullLoginLink} onClick={handleContinueToLoginClick}>
                            {`${language.unverified.descStaffCTA}`}
                        </Link>
                    </p>
                </footer>
            </Card>
            <section className={styles.resendEmail}>
                <Link role="button" onClick={handleResendEmailClick}>
                    {language.unverified.resendEmail}
                </Link>
            </section>
            <Snackbar open={showToaster}>
                <Alert severity="success">{language.unverified.resendSuccess}</Alert>
            </Snackbar>
        </>
    );
};

const UnverifiedStaffAccountUi: FC = () => {
    const { unverifiedStaffAccountUiState } = useContext(UnverifiedStaffAccountContext);
    let unverifiedStaffAccountUi: React.ReactElement;
    switch (unverifiedStaffAccountUiState) {
        case EUnverifiedStaffAccountUiState.default:
        case EUnverifiedStaffAccountUiState.loading:
        case EUnverifiedStaffAccountUiState.success:
            unverifiedStaffAccountUi = <Unverified />;
            break;
        case EUnverifiedStaffAccountUiState.error:
            unverifiedStaffAccountUi = <Redirect to={ERoutes.error} />;
            break;
        default:
            throw new Error('Unverified Staff Account UI state set incorrectly');
    }
    return unverifiedStaffAccountUi;
};

const UnverifiedStaffAccountScreen: FC = () => {
    return (
        <UnverifiedStaffAccountProvider>
            <PageLayout>
                <UnverifiedStaffAccountUi />
            </PageLayout>
        </UnverifiedStaffAccountProvider>
    );
};

export default UnverifiedStaffAccountScreen;
